import { render, staticRenderFns } from "./LoraSettings.vue?vue&type=template&id=deba0788&"
import script from "./LoraSettings.vue?vue&type=script&lang=ts&"
export * from "./LoraSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports